import { configureLazySizes } from './initLazySizes'
import loadPolyfills from './polyfills'

configureLazySizes()

loadPolyfills().then(() => {
  require('./hydrateApp')
})
